import { render } from "./IconsLoading.vue?vue&type=template&id=1dd6d472"
import script from "./IconsLoading.vue?vue&type=script&lang=js"
export * from "./IconsLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/loaders/IconsLoading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1dd6d472"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1dd6d472', __exports__)) {
    api.reload('1dd6d472', __exports__)
  }
  
  module.hot.accept("./IconsLoading.vue?vue&type=template&id=1dd6d472", () => {
    api.rerender('1dd6d472', render)
  })

}


export default __exports__